import WHowProtection from './WHowProtection'

export default WHowProtection
